import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareComponent } from './share.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    DropdownModule,
    ButtonModule,
  ],
  declarations: [
    ShareComponent,
  ],
  exports: [
    ShareComponent,
  ]
})
export class ShareModule {}
